module.exports = __webpack_public_path__ + "static/media/iStock-1185065140.c33c111e.jpg";